module.exports = __webpack_public_path__ + "img/VL_21_03.06d8c6cd.png";